var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCreditCardBlueInverse = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.986 4h-15.986c-0.002 0-0.005-0-0.007-0-1.095 0-1.983 0.888-1.983 1.983 0 0.006 0 0.012 0 0.018v-0.001l-0.010 11.992c0 0.002-0 0.005-0 0.008 0 1.1 0.892 1.992 1.992 1.992 0.003 0 0.006 0 0.008-0h15.986c0.002 0 0.005 0 0.008 0 1.1 0 1.992-0.892 1.992-1.992 0-0.003 0-0.006-0-0.008v0-11.992c0-0.002 0-0.005 0-0.008 0-1.1-0.892-1.992-1.992-1.992-0.003 0-0.006 0-0.008 0h0zM19.986 17.992h-15.986v-5.992h15.986zM19.986 7.998h-15.986v-1.998h15.986z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#009af6",
    d: "M21.985 7.989h-19.976v4h19.976z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCreditCardBlueInverse, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/credit-card-blue-inverse.d4be5935.svg";
export { ForwardRef as ReactComponent };